import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import {
  applyBatteryConcertApplicationStatus,
  invalidateBatteryConcertApplication,
} from "./battery-concert-application-cache"
import type {
  BatteryConcertApplicationStatusDto,
  SubmitBatteryConcertApplicationDto,
} from "../dto/battery-concert-application.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Submit the in-person Concert application for the current Quote. The server
 * owns the financed amount and idempotency; a rejected attempt still persists
 * a failed or uncertain Existing Loan Application, so errors refetch status.
 */
export default function useSubmitBatteryConcertApplication(): UseMutationResult<
  BatteryConcertApplicationStatusDto,
  unknown,
  { proposalId: string; body: SubmitBatteryConcertApplicationDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.submitConcertApplication(proposalId, body),
    onSuccess: (status, { proposalId }) => {
      applyBatteryConcertApplicationStatus(queryClient, proposalId, status)
    },
    onError: (_error, { proposalId }) => {
      invalidateBatteryConcertApplication(queryClient, proposalId)
    },
  })
}
